// ControlNumericStepperFactory.js

import $ from 'jquery';

import BaseVisualControlFactory from 'BaseVisualControlFactory.js';
import factoryService   from 'FactoryService.js';
import constants        from 'Constants.js';
import sequenceService  from 'SequenceService.js';

import ControlModel    from 'ControlModel.js';
import NumericStepperControlView  from 'advanced-inputs/NumericStepperControlView.js';


//=============================================================================
//
// Creates a numeric stepper control, given a factoryService
// parameter key and a layout position. The factory key defines the
// control appearance through its template. It defines the initial rectangle
// of the control via a width and height from the factory parameter.
//
// Maty Rocha, January 16, 2016
//
//=============================================================================
class ControlNumericStepperFactory extends BaseVisualControlFactory {

    constructor () {
        super();
    }

    createView( factoryKey, pos ) {

        const attributes = this.createChildAttributes( factoryKey, pos ) ;

        //adding silent(accessibility) to attributes.
        attributes.silent = false;
        attributes.stepSize = 1;
        attributes.minValue = 1;
        attributes.maxValue = 100;
        attributes.value = 1;
        //adding silent(accessibility) to attributes.
        attributes.silent = false;
        attributes.styleColorText ='~inputTextColor';
        attributes.fontFamily = '~inputFont';
        attributes.fontSize = '~inputFont';
        attributes.textWeight = '~inputFont';
        attributes.textStyle  = '~inputFont';
        attributes.borderStyle= '~inputBorder';
        attributes.borderSize= '~inputBorder';
        attributes.cornerRadius= '~inputBorder';
        attributes.borderColor = '~inputBorderColor';
        attributes.styleBGColorText = '~inputBgColor';
        attributes.backgroundColor = '~inputBgColor';
        attributes.resizePadding = 2;
		attributes.minWidth = 22;
		attributes.lowestHeight = 15;
        this.resolveForInitialMinHeight(attributes);
        attributes.translateProps = [
            {key:"toolTip", label:"Tooltip"},
            {key:"accessDesc", label:"Accessibility Description"},
        ];

        const view = new NumericStepperControlView( { model: new ControlModel( attributes ),  el: $(constants.FORM_ID),
            pos: pos, factoryKey: factoryKey, id: attributes.id } );

        return view;
    }

}

const controlNumericStepperFactory = new ControlNumericStepperFactory();

export default controlNumericStepperFactory;